"use strict";
var base = require("./base");
var debounce = require("lodash/debounce");
var bis = require("./bis");
var babolatCupForm = require("./babolatCupForm");
var sizeGuidePopin = require("./sizeGuidePopin");

/**
 * @function
 * @description function to adjust sticky scroll top settings
 **/
const adjustStickyScrollTop = () => {
    let $stickyBar = $(".m-product-detail__sticky-arrow");
    let $productTitleMobile = $(".m-product-detail__product-name.d-md-none");
    let $productTitleTablet = $(".m-product-detail__product-name.d-md-block");

    if (!window.mqRespond.status.lgUp && $stickyBar.length) {
        let $headerHeight = $(".l-header").outerHeight();
        let $mobileScrollLimit = $productTitleMobile.offset().top - $headerHeight + $productTitleMobile.outerHeight();
        let $tabletScrollLimit = $productTitleTablet.offset().top - ($productTitleTablet.outerHeight() + 40);
        let $mobileConditions = (window.mqRespond.status.smOnly || window.mqRespond.status.xsOnly) && $(window).scrollTop() > $mobileScrollLimit;
        let $tabletConditions = (window.mqRespond.status.mdOnly || window.mqRespond.status.mdUp) && $(window).scrollTop() > $tabletScrollLimit;

        if ($mobileConditions || $tabletConditions) {
            if ($stickyBar.hasClass("d-none")) {
                $stickyBar.removeClass("d-none");
            }
        } else {
            if (!$stickyBar.hasClass("d-none")) {
                $stickyBar.addClass("d-none");
            }
        }
    }
};

module.exports = {
    availability: base.availability,
    handleProductImagesZoom: base.handleProductImagesZoom,
    addToCart: base.addToCart,
    selectColor: function () {
        var $colorContainer = $(".m-product-detail__attribute-color");
        var isColorSelected = $colorContainer.find("span.selected").length;
        var isColorSelectable = $colorContainer.find("span.selectable").length;

        if (isColorSelectable) {
            if (!isColorSelected) {
                var $colorButton = $colorContainer.find("span.selectable").first().closest("button.color-attribute");
                $colorButton.trigger("click");
            } else {
                var $selectedColorContainer = $colorContainer.find(".m-product-detail__attribute-selected-value");
                var displayValue = $colorContainer.find("span.selected").data("attr-display-value");
                $selectedColorContainer.empty().html(displayValue);
                $selectedColorContainer.addClass("m-product-detail__attribute-disabled");
            }
        }
    },
    updateAttributesAndDetails: function () {
        $("body").on("product:statusUpdate", function (e, data) {
            var $productContainer = $(".product-detail[data-pid=\"" + data.id + "\"]");

            $productContainer.find(".description-and-detail .product-attributes")
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find(".description-and-detail .description")
                    .removeClass("hidden-xl-down");
                $productContainer.find(".description-and-detail .description .content")
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find(".description-and-detail .description")
                    .addClass("hidden-xl-down");
            }

            if (data.longDescription) {
                $productContainer.find(".description-and-detail .details")
                    .removeClass("hidden-xl-down");
                $productContainer.find(".description-and-detail .details .content")
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find(".description-and-detail .details")
                    .addClass("hidden-xl-down");
            }
        });
    },
    showSpinner: function () {
        $("body").on("product:beforeAddToCart product:beforeAttributeSelect", function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $("body").on("product:afterAttributeSelect", function (e, response) {
            if ($(".product-detail>.bundle-items").length || $(".product-set-detail").eq(0)) {
                response.container.data("pid", response.data.product.id);
                response.container.find(".product-id").text(response.data.product.id);
            } else {
                $(".product-id").text(response.data.product.id);
                $(".product-detail:not(\".bundle-item\")").data("pid", response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $("body").on("product:updateAddToCart", function (e, response) {

            if (response.isSetItem) {
                return;
            }
            if (response.product.orderable === false || response.product.hideAddToCart) {

                $("button.add-to-cart", response.$productContainer).attr("disabled", true).addClass("d-none");
                $("button.add-to-cart-global").attr("disabled", true).addClass("d-none");
                $("span.find-dealer-btn").removeClass("d-none");
                return;
            }

            if (!response.product.available && (response.product.isStringable || response.product.isEstringingProduct)) {
                $("button.btn-stringing", response.$productContainer).parent().addClass("d-none");
                $(".cart-and-ipay").addClass("full-width-CTA");
            } else {
                $("button.btn-stringing", response.$productContainer).parent().removeClass("d-none");
                $(".cart-and-ipay").removeClass("full-width-CTA");
            }

            if (response.product.isCTADisabled) {
                $("button.add-to-cart", response.$productContainer).attr("disabled", true);
                $("button.btn-stringing", response.$productContainer).attr("disabled", true);
                return;
            }

            // update local add to cart (for sets)
            var buttonState = (!response.product.readyToOrder || !response.product.available);

            if (response.product.isPlayTest) {
                buttonState = response.isUserInBlockedGroupPlayTest || !(response.product.playTestEnabled) || buttonState;
                $("button.add-to-cart", response.$productContainer).toggleClass("pt-active", false);
            }

            $("button.add-to-cart", response.$productContainer).attr("disabled", buttonState).removeClass("d-none");
            $("button.btn-stringing", response.$productContainer).attr("disabled", buttonState).toggleClass("stringing-active", false);

            // Updates the free delivery message on the variation change
            if ($("#find-stringing-shop") && $("#find-stringing-shop").length && !$("#find-stringing-shop").hasClass("d-none")) {
                $(".msg-free-delivery").addClass("d-none");
                $(".msg-free-delivery-stringing").removeClass("d-none");
            } else {
                $(".msg-free-delivery-stringing").addClass("d-none");
                $(".msg-free-delivery").removeClass("d-none");
            }

            var enable = $(".product-availability").toArray().every(function (item) {
                var $item = $(item);

                return $item.data("available") && $item.data("ready-to-order");
            });

            $("button.add-to-cart-global").attr("disabled", !enable).removeClass("d-none");
            $("span.find-dealer-btn").addClass("d-none");
        });
    },
    updateAvailability: function () {
        $("body").on("product:updateAvailability", function (e, response) {
            $("div.availability", response.$productContainer)
                .data("ready-to-order", response.product.readyToOrder)
                .data("available", response.product.available);

            $(".availability-msg", response.$productContainer)
                .empty().html(response.message);

            $("button.add-to-cart").empty()
                .html(!response.product.available ? response.resources.outOfStock : (response.product.readyToOrder ? (response.product.isPlayTest ? response.resources.playTest : response.resources.addtocartText) : response.resources.info_selectforstock));

            if ($(".global-availability").length) {
                var allAvailable = $(".product-availability").toArray()
                    .every(function (item) { return $(item).data("available"); });

                var allReady = $(".product-availability").toArray()
                    .every(function (item) { return $(item).data("ready-to-order"); });

                $(".global-availability")
                    .data("ready-to-order", allReady)
                    .data("available", allAvailable);

                $(".global-availability .availability-msg").empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $(".size-chart a").on("click", function (e) {
            e.preventDefault();
            let url = $(this).attr("href");
            let isDetailed= $(this).hasClass("js-detailed-size-guide");

            if (isDetailed && $("#sizeGuideModal").length) {
                $("#sizeGuideModal").modal("show");

                return;
            }

            $.ajax({
                url: url,
                type: "get",
                dataType: "json",
                success: function (data) {
                    $("body").append(data.modalTemplate);
                    $(isDetailed ? "#sizeGuideModal" : "#sizeChartModal").modal("show");
                }
            });
        });
    },
    copyProductLink: function () {
        $("body").on("click", "#fa-link", function () {
            event.preventDefault();

            var $temp = $("<input>");

            $("body").append($temp);
            $temp.val($("#shareUrl").val()).select();
            document.execCommand("copy");
            $temp.remove();

            var $copyLinkMessage = $(".copy-link-message");

            $copyLinkMessage.attr("role", "alert");
            $copyLinkMessage.removeClass("d-none");
            setTimeout(function () {
                $(".copy-link-message").addClass("d-none");
            }, 3000);
        });
    },
    scrollToReviews: function () {
        $("body").on("click", "#ratings-summary, .bv_button_buttonFull", function () {
            var reviews = $(".m-product-detail__reviews");
            var header = $(".l-header");
            var mainContent = $("#maincontent");
            header.removeClass("fixed-top");
            mainContent.css("margin-top", 0);
            var headerHeight = header[0].offsetHeight;

            if (reviews.length) {
                var reviewsPosition = reviews[0].offsetTop - headerHeight;

                $(window).scrollTop(reviewsPosition);
                header.addClass("fixed-top");
                mainContent.css("margin-top", headerHeight);
            }
        });
    },
    showStickyBottomButton: () => {
        $(window).on("scroll resize", debounce(() => {
            adjustStickyScrollTop();
        }, 100));
    },
    scrollToTop: () => {
        let $productTitleMobile = $(".m-product-detail__product-name.d-md-none");
        let $productTitleTablet = $(".m-product-detail__product-name.d-md-block");

        $("body").on("click", ".js-scroll-top-button", function () {
            var $domElements = $("html,body");

            if (window.mqRespond.status.smOnly || window.mqRespond.status.xsOnly) {
                $domElements.animate({
                    scrollTop: $productTitleMobile.offset().top - $(".l-header").outerHeight() - 10
                }, 500);
            } else {
                $domElements.animate({
                    scrollTop: $productTitleTablet.offset().top - $(".l-header").outerHeight() - 4
                }, 500);
            }
        });
    },
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    backinstockEvents: bis.backinstockEvents(),
    babolatCupForm: babolatCupForm.init(),
    sizeGuidePopin: sizeGuidePopin.init()
};
